export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'i',
'_.loadingSpinnerText': 'Proszę czekać...',
'pageTimerMax.text': 'Po upływie czasu nastąpi automatyczne przejście do następnej strony.',
'pageTimerMax.timeLeft': 'Pozostały czas',
'pageTimerMin.text': 'Przed upływem czasu nie ma możliwości przejścia dalej.',
'pageTimerMin.timeLeft': 'Pozostały czas',
'pageTimerMin.allowNext': 'Możesz przejść dalej',
'survey.registerForm.label.email': 'Email',
'survey.registerForm.label.newsletter': 'Chcę otrzymywać newsletter',
'survey.registerForm.label.regulations': 'Akceptuję Politykę prywatności i Regulamin',
'survey.registerForm.button.register': 'Zarejestruj',
'survey.registerForm.registered': 'Dziękujemy za rejestrację. Na Twoją skrzynkę została wysłana wiadomość z linkiem aktywacyjnym.',
'survey.registerForm.cardHeader': 'Zarejestruj się i odbierz punkty!',
'survey.registerForm.cardBody': 'Za wypełnienie ankiety otrzymałeś/aś ',
'survey.registerForm.cardBody2': 'Punkty zostaną dopisane po rejestracji konta w swpanel.pl. Podaj swój adres email i zarejestruj konto w swpanel.pl by zdobywać więcej punktów i wymieniać je na atrakcyjne nagrody.',
'survey.notProperDevice': 'Niestety, nie możesz wypełnić tej ankiety na tym urządzeniu.',
'survey.properDevices': 'Ankieta jest dostępna z następujących urządzeń: ',
'survey.device-phone': 'smartfon',
'survey.device-tablet': 'tablet',
'survey.device-desktop': 'komputer / laptop',
'survey.device-android': '<a href="https://play.google.com/store/apps/details?id=org.reactjs.swpanel">Aplikacja swpanel na urządzeniu mobilnym z systemem Android</a>',
'survey.device-ios': '<a href="https://apps.apple.com/pl/app/swpanel/id6449539314">Aplikacja swpanel na urządzeniu mobilnym z systemem iOS</a>',
'nextSurveys.header.seeAlso': 'Zobacz także inne ankiety',
'nextSurveys.button.fill': 'Wypełnij',
'question.noContent': 'Brak treści pytania',
'question.input.placeholder.typeYourAnswer': 'Wpisz odpowiedź',
'question.slider.input': "Kliknij aby wpisać wartość ręcznie.",

'question.conjoint.go': 'Kliknij przycisk "Dalej"',
'question.matrix.carousel.go': 'Kliknij przycisk "Dalej"',
'question.matrix.columnsMin': 'Minimalna liczba kolumn to:',
'question.matrix.rowsMin': 'Minimalna liczba wierszy to:',
'question.carousel.prevBtn': 'Poprzednie stwierdzenie',
'question.carousel.nextBtn': 'Następne stwierdzenie',

'question.basket.moveToBaskets': "Przenieś do koszyków",
'question.dragAndDrop.moveToTarget': "Przenieś na skalę",

'question.open.email.inputPlaceholder': 'Wpisz adres email',
'question.open.email.emailVerify.sendCode': 'Wyślij kod weryfikacyjny',
'question.open.email.emailVerify.enderCode': 'Wprowadź otrzymany kod',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Wpisz kod',
'question.open.email.emailVerify.confirm': 'Weryfikuj',
'question.open.email.emailVerify.codeIncorrect': 'Wpisany kod jest niepoprawny',
'question.open.email.emailVerify.codeCorrect': 'Adres email poprawnie zweryfikowany',
'question.open.email.rodoText': 'Administratorem Twoich danych osobowych jest SW Research Sp. z o.o. z siedzibą w Warszawie ul. J. Dąbrowskiego 64a, 02-561 Warszawa. W sprawach ochrony swoich danych osobowych i realizacji swoich praw możesz skontaktować się z Inspektorem Ochrony Danych przez e-mail iod@swresearch.pl. Twoje dane osobowe przetwarzane są w czasie realizacji badania, dokumentacja księgowa – 5 lat po zakończeniu roku, w którym odbyły się badania. Twoje dane osobowe przetwarzamy w celach: udziału w badaniach opinii, w celach analitycznych, tj. doboru usług do potrzeb naszych klientów, ;przechowywaniu dokumentacji księgowej (art. 6 ust.1 lit.b RODO, art. 6 ust. 1 lit. F RODO, art. 6 ust.1 lit. C RODO w związku z art. 86 § 1 Ordynacji podatkowej).',
'question.dropdown.open': 'Wybierz...',
'question.column': "Kolumna",
'question.matrix.nextStatement': 'Następne stwierdzenie',
'question.matrix.previousStatement': 'Poprzednie stwierdzenie',

'footer.pauseButton.text': 'Wstrzymaj wypełnianie',
'footer.buttonPrev.text': 'Cofnij',
'footer.buttonClear.text': 'Wyczyść',
'footer.buttonNext.text': 'Dalej',
'footer.buttonEnd.text': 'Zakończ',
'footer.buttonStart.text': 'Rozpocznij ankietę',
};
